import React, { Component } from 'react';
import Chart from "react-apexcharts";
import { postDashboardForm } from '../api/apiClient'
import { Circles } from 'react-loader-spinner'
import { MenuComponent } from '../../_metronic/assets/ts/components'
import { ROCELL_COLORS } from '../theme/rocellTheme';
import { buildLineChartOptions } from '../theme/chartOptions';

export class TTCBCchart extends Component {
    constructor() {
        super()
        this.state = {
            options: {
                chart: {
                    type: "bar"
                },
                xaxis: {
                    categories: []
                }
            },
            series: [],
            isLoaded: false,
            filterDateTo: '',
            filterDateFrom: '',
            lineChart : {
                series: [
                  {
                    name: "Shipment Cost",
                    data: []
                  }
                ],
                options: buildLineChartOptions([], { colors: [ROCELL_COLORS.brandBlue] }),
            }
        };
        this.componentDidMount = this.componentDidMount.bind(this)
        this.componentDidUpdate = this.componentDidUpdate.bind(this)
        this.filterChange = this.filterChange.bind(this)
        this.updateChart = this.updateChart.bind(this)
    }

    initFilterMenu() {
        setTimeout(() => {
            MenuComponent.reinitialization()
        }, 0)
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.isLoaded !== this.state.isLoaded) {
            this.initFilterMenu()
        }
    }

    updateState(name, data) {
        const newSeries = {
            name: name,
            data: data
        };

        this.setState((prevState) => ({
            series: [...prevState.series, newSeries]
        }));
    }

    updateLineChart(cost,month){

    }
   
    updateLoader(stateValue) {
        if (this.state.isLoaded === true) {
            this.setState({ isLoaded: false })
        } else {
            this.setState({ isLoaded: stateValue })
        }
    }

    updateCategories(newCategories) {
        this.setState((prevState) => ({
            options: {
                ...prevState.options, // Preserve other properties in the options object
                xaxis: {
                    ...prevState.options.xaxis, // Preserve other properties in xaxis
                    categories: newCategories, // Update categories with the new data
                },
            },
        }));
    }

    filterChange(key, event) {
        console.log(key + " " + event.target.value)
        if (key == 'to') {
            this.setState({ filterDateTo: event.target.value })
        } else if (key == 'from') {
            this.setState({ filterDateFrom: event.target.value })
        }
    }

    getData(formData) {
        const API_URL = process.env.REACT_APP_API_URL
        const dataUrl = API_URL + "/Bi_dashboard_ttc_bc"

        const data_record = [];
        const data_name = [];

        postDashboardForm(dataUrl, formData).then((response) => {
            if (response.data.success) {
                const reportData = response.data.data;
                reportData.forEach(item => {
                    data_record.push(item.tms_shp_trip_cost);
                    data_name.push(item.sup_code);
                });
                const costs = response.data.costs;
                const months = response.data.months;
                this.setState({
                    series: [{ name: "Cost", data: data_record }],
                    options: {
                        chart: { type: "bar" },
                        xaxis: { categories: data_name },
                    },
                    lineChart: {
                        series: [{ name: "Shipment Cost", data: costs }],
                        options: buildLineChartOptions(months, { colors: [ROCELL_COLORS.brandBlue] }),
                    },
                    isLoaded: true,
                })
            } else {
                console.log("No data returned from API")
                this.updateLoader(true)
            }

        }).catch(function (error) {
            console.log(error);
        });
    }

    updateChart() {
        const filterDateTo = this.state.filterDateTo;
        const filterDateFrom = this.state.filterDateFrom;
        const formData = new FormData();
        formData.append('filter_date_to', filterDateTo);
        formData.append('filter_date_from', filterDateFrom);
        this.setState({ isLoaded: false })
        this.getData(formData);
    }

    componentDidMount() {
        const formData = new FormData();
        var currentDate = new Date();

        currentDate = new Date(currentDate.getTime() - 86400000);
        var formattedDateFrom = currentDate.toISOString().split('T')[0];

        currentDate = new Date();
        var formattedDateTo = currentDate.toISOString().split('T')[0];

        formData.append('filter_date_to', formattedDateTo);
        formData.append('filter_date_from', formattedDateFrom);

        this.setState({ filterDateTo: formattedDateTo })
        this.setState({ filterDateFrom: formattedDateFrom })

        this.getData(formData);
    }

    render() {
        return (
            <div className='card bi-chart-card'>
                <div className='card-header border-0'>
                    <div className='row align-items-center'>
                        <div className='col-lg-5'>
                            <p className='card-title mb-0'>
                                <span className='card-label fw-bold'>
                                    Total Transport Cost — Monthly Trend
                                    <span className='bi-date-muted d-block mt-1'>{this.state.filterDateFrom} to {this.state.filterDateTo}</span>
                                </span>
                            </p>
                        </div>
                        <div className='col-lg-7 bi-chart-actions mt-3 mt-lg-0'>
                            <div className='d-flex align-items-center'>
                            <button
                                type='button'
                                className='btn btn-sm btn-light-primary'
                                data-kt-menu-trigger='click'
                                data-kt-menu-placement='bottom-end'
                                data-kt-menu-flip='top-end'>
                                <i className='fas fa-filter me-1'></i> Filter
                            </button>

                            <div className='menu menu-sub menu-sub-dropdown w-250px w-md-300px' data-kt-menu='true'>
                                <div className='px-7 py-5'>
                                    <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
                                </div>

                                <div className='separator border-gray-200'></div>

                                <div className='px-7 py-5'>
                                    <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter From Date:</label>
                                        <div>
                                            <input type="Date" name='date' value={this.state.filterDateFrom}
                                                onChange={(event) => this.filterChange('from', event)}
                                                className='form-control' />
                                        </div>
                                    </div>

                                    <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter To Date:</label>
                                        <div>
                                            <input type="Date" name='date' value={this.state.filterDateTo}
                                                onChange={(event) => this.filterChange('to', event)}
                                                className='form-control' />
                                        </div>
                                    </div>

                                    <div className='d-flex justify-content-end'>
                                        <button
                                            type='reset'
                                            className='btn btn-sm btn-white btn-active-light-primary me-2'
                                            data-kt-menu-dismiss='true'>
                                            Reset
                                        </button>

                                        <button type='submit' className='btn btn-sm btn-primary' data-kt-menu-dismiss='true' onClick={this.updateChart}>
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='card-body'>
                    <div className={`bi-chart-area bi-chart-area--line${!this.state.isLoaded ? ' bi-chart-area--loading' : ''}`}>
                        {!this.state.isLoaded ? (
                            <Circles
                                height="80"
                                width="80"
                                color={ROCELL_COLORS.accent}
                                ariaLabel="circles-loading"
                                visible={true}
                            />
                        ) : (
                            <Chart
                                options={this.state.lineChart.options}
                                series={this.state.lineChart.series}
                                type="line"
                                width="100%"
                                height={420}
                            />
                        )}
                    </div>
                </div>
            </div>
        )
    }
}